import React, { useState } from 'react';
import './Reports.css';
import LineChart from './../charts/LineChart.js';

const Reports = () => {
    const chartValues = {
        HRV: {
            morning: [97.4, 83.1, 72.9, 35.1, 69.7, 122.6, 39.1],
            evening: [63.9, 94.2, 54.3, 82.2, 78.5, 128.2, 37.2]
        },
        LF_HF_Ratio: {
            morning: [1.547, 1.734, 2.231, 1.698, 2.672, 2.382, 1.625],
            evening: [1.7, 1.366, 2.11, 2.948, 2.517, 2.467, 3.016]
        },
        PNS_Index: {
            morning: [2.1, 2.6, 1.1, 4.9, 1.2, 2.9, 0.4],
            evening: [2.4, 4.4, 2.3, 0.3, 1.5, 2.9, 0]
        },
        SNS_Index: {
            morning: [-0.4, -4.1, -1.3, -0.7, -3.5, -0.5, -5],
            evening: [-3.1, -1.3, -3.5, -0.2, -2.9, -3.8, -2.3]
        },
        Mean_HR: {
            morning: [52, 58, 49, 61, 54, 62, 70],
            evening: [60, 70, 56, 40, 53, 59, 52]
        },
        Max_HR: {
            morning: [97, 110, 92, 107, 99, 84, 87],
            evening: [94, 86, 86, 80, 81, 107, 95]
        },
        Min_HR: {
            morning: [32, 31, 38, 31, 27, 38, 29],
            evening: [24, 23, 21, 39, 23, 37, 37]
        }
    };

    const [selectedOption, setSelectedOption] = useState('HRV');
    const [chartData, setChartData] = useState({
        datasets: [
            {
                label: 'Morning Metric',
                data: chartValues[selectedOption].morning,
                borderColor: 'rgba(66, 107, 179, 1)',
                backgroundColor: 'rgba(66, 107, 179, 0.2)',
                fill: true,
            },
            {
                label: 'Evening Metric',
                data: chartValues[selectedOption].evening,
                borderColor: 'rgba(255, 0, 0, 1)',
                backgroundColor: 'rgba(255, 0, 0, 0.2)',
                borderDash: [5, 5],  // Dashed line
                borderWidth: 2
            },
        ],
        chartTitle: 'HRV',
        yAxisLabel: selectedOption
    });

    const handleChange = (event) => {
        const selectedVal = event.target.value;
        setSelectedOption(selectedVal);
        const chartData = {
            datasets: [
                {
                    label: 'Morning Metric',
                    data: chartValues[selectedVal].morning,
                    borderColor: 'rgba(255, 0, 0, 1)',
                    backgroundColor: 'rgba(255, 0, 0, 0.2)',
                    borderDash: [5, 5],  // Dashed line
                    borderWidth: 2
                },
                {
                    label: 'Evening Metric',
                    data: chartValues[selectedVal].evening,
                    borderColor: 'rgba(66, 107, 179, 1)',
                    backgroundColor: 'rgba(66, 107, 179, 0.2)',
                    borderDash: [5, 5],  // Dashed line
                    borderWidth: 2
                },
            ],
            chartTitle: selectedVal.replace(/_/g, ' '),
            yAxisLabel: selectedVal
        };
        setChartData(chartData);
    };

    return (
        <div className="container">
            <div className="main-content">
                <section className="card">
                    <div className="reports-container">
                        <h3 className="radio-header">Select a metric:</h3>
                        <div className="radio-button-container">
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="hrv"
                                    name="option"
                                    value="HRV"
                                    checked={selectedOption === 'HRV'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="hrv">HRV</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="lfhf"
                                    name="option"
                                    value="LF_HF_Ratio"
                                    checked={selectedOption === 'LF_HF_Ratio'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="lfhf">LF/HF Ratio</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="pns"
                                    name="option"
                                    value="PNS_Index"
                                    checked={selectedOption === 'PNS_Index'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="pns">PNS Index</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="sns"
                                    name="option"
                                    value="SNS_Index"
                                    checked={selectedOption === 'SNS_Index'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="sns">SNS Index</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="avgHr"
                                    name="option"
                                    value="Mean_HR"
                                    checked={selectedOption === 'Mean_HR'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="avgHr">Mean HR</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="minHr"
                                    name="option"
                                    value="Min_HR"
                                    checked={selectedOption === 'Min_HR'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="minHr">Min HR</label>
                            </div>
                            <div className="radio-button">
                                <input
                                    type="radio"
                                    id="maxHr"
                                    name="option"
                                    value="Max_HR"
                                    checked={selectedOption === 'Max_HR'}
                                    onChange={handleChange}
                                    className="radio-input"
                                />
                                <label htmlFor="maxHr">Max HR</label>
                            </div>
                        </div>
                        <LineChart chartData={chartData} />
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Reports;